import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../components/Layouts/Main/MainLayout.index";
import { getAllADListForUser } from "../../api/project";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ADList() {
  const [adList, setAdList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 一覧取得
  useEffect(() => {
    const fetchAds = async () => {
      setLoading(true);
      try {
        const searcheConditon = {
          checkToken: "jankatsu_token",
        };
        const res = await getAllADListForUser(searcheConditon);
        if (res.code === 200) {
          setAdList(res.data);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchAds();
  }, []);

  // URLコピー
  const copyUrl = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("URLをコピーしました");
    } catch (e) {
      toast.error("コピーに失敗しました");
    }
  };

  // 詳細画面へ遷移
  const goDetail = (adId, adName) => {
    sessionStorage.setItem("ad_banner_id", adId);
    sessionStorage.setItem("ad_banner_name", adName);
    navigate("/dashboard");
  };

  return (
    <MainLayout>
      <h2>広告一覧</h2>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
      />
      {loading ? (
        <div style={{ padding: "20px" }}>読み込み中...</div>
      ) : (
        <>
          <table
            style={{ width: "100%", borderCollapse: "collapse" }}
            border="1"
          >
            <thead>
              <tr>
                <th>広告名</th>
                <th>広告URL（ユーザー提示用）</th>
                <th>操作</th>
              </tr>
            </thead>

            <tbody>
              {adList.length === 0 ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    データがありません
                  </td>
                </tr>
              ) : (
                adList.map((ad, index) => {
                  const adUrl =
                    process.env.REACT_APP_AD_URL +
                    "\n" +
                    ad.user_id +
                    "/" +
                    ad.password;

                  return (
                    <tr key={index}>
                      <td>{ad.ad_name}</td>
                      <td>
                        {ad.user_id != null ? (
                          <>
                            {ad.user_id}/{ad.password}
                            <button
                              onClick={() => copyUrl(adUrl)}
                              style={{ marginLeft: "8px" }}
                            >
                              📋
                            </button>
                          </>
                        ) : null}
                      </td>

                      <td>
                        <button onClick={() => goDetail(ad.ad_id, ad.ad_name)}>
                          詳細
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
          {/* 👇 画面底部の余白 */}
          <div style={{ height: "100px" }} />
        </>
      )}
    </MainLayout>
  );
}

export default ADList;
